export const marginLeft = {larger:"50px", small:"20px"};